'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Features$() {
  this.oA = null;
  this.YV = null;
  this.Ls = null;
  this.qm = null;
  this.Lr = null;
  this.xC = null;
  this.oA = "credentials";
  this.YV = "vault";
  this.Ls = "2fa";
  this.qm = "block";
  this.Lr = "sign_documents";
  this.xC = "presto_sign";
}
export { $c_Lpresto_types$Features$ as $c_Lpresto_types$Features$ };
$p = $c_Lpresto_types$Features$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Features$;
/** @constructor */
function $h_Lpresto_types$Features$() {
}
export { $h_Lpresto_types$Features$ as $h_Lpresto_types$Features$ };
$h_Lpresto_types$Features$.prototype = $p;
var $d_Lpresto_types$Features$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Features$, "presto.types$Features$", ({
  a0e: 1
}));
export { $d_Lpresto_types$Features$ as $d_Lpresto_types$Features$ };
var $n_Lpresto_types$Features$;
function $m_Lpresto_types$Features$() {
  if ((!$n_Lpresto_types$Features$)) {
    $n_Lpresto_types$Features$ = new $c_Lpresto_types$Features$();
  }
  return $n_Lpresto_types$Features$;
}
export { $m_Lpresto_types$Features$ as $m_Lpresto_types$Features$ };
//# sourceMappingURL=presto.types$-Features$.js.map
